import MUIGridGloabl from 'components/MuiGrid/MUIGlobalGrid';
import Toast, { ToastTypes } from 'components/ToastNotify';
import {
	GetAuthorizePaymentStatus,
	RefundAmount,
	VoidTransaction,
} from 'firebaseApis/payments';
import { IOrderData, IPaymentDetailsInOrder } from 'interfaces';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from 'reducers/Alerts/AlertActions';

import { IPos } from 'reducers/POS';
import Button from 'storybook-mui/build/components/Button';

function Transactions({
	orderData,
	refreshOrder,
	setSelectedIndex,
}: ITransactions) {
	const [tempDataSource, setTempdataSource] = useState<any>([]);
	const { currency }: IPos = useSelector((state: any) => state.posReducer);
	const dispatch: any = useDispatch();
	const getStatus = async () => {
		setTempdataSource([]);
		try {
			dispatch(showLoading());
			orderData?.payment_details?.forEach(
				async (payment: IPaymentDetailsInOrder, index: number) => {
					let tempStatus = '';

					if (
						payment.transactionType === 'virtualCard' ||
						payment.transactionType === 'paypal'
					) {
						const response = await GetAuthorizePaymentStatus(payment.transactionid);
						if (response?.data.transactionStatus === 'capturedPendingSettlement') {
							tempStatus = 'Unsettled';
						}
						if (response?.data?.transactionStatus === 'settledSuccessfully') {
							tempStatus = 'Settled';
						}
						if (response?.data?.transactionStatus === 'voided') {
							tempStatus = 'Voided';
						}
						if (response?.data?.transactionStatus === 'refundPending') {
							tempStatus = 'Refund Pending';
						}
						if (response?.data?.transactionStatus === 'refundFailed') {
							tempStatus = 'Refund Failed';
						}
						if (response?.data?.transactionStatus === 'refundSuccess') {
							tempStatus = 'Refund Success';
						}
						if (
							orderData?.refund_details?.find(
								(refund: any) => refund?.ref_txn_id === payment?.transactionid
							)
						) {
							tempStatus = 'Refunded';
						}
						setTempdataSource((prev) => [
							...prev,
							{
								...payment,
								id: index,
								status: tempStatus,
							},
						]);
					} else {
						tempStatus = 'Settled';
						if (
							orderData?.refund_details?.find(
								(refund: any) => refund?.ref_txn_id === payment?.transactionid
							)
						) {
							tempStatus = 'Refunded';
						}
						setTempdataSource((prev: any) => [
							...prev,
							{
								...payment,
								id: index,
								status: tempStatus,
							},
						]);
					}
				}
			);
			dispatch(hideLoading());
		} catch (error) {
			dispatch(hideLoading());
			setTempdataSource([]);
		}
	};

	const refund = async (data: IPaymentDetailsInOrder) => {
		try {
			let { transactionType } = data;
			if (
				data.transactionType === 'virtualCard' ||
				data.transactionType === 'virtualCards'
			) {
				transactionType = 'virtualCard';
			}
			if (
				data.transactionType === 'physicalCards' ||
				data.transactionType === 'physicalCard'
			) {
				transactionType = 'physicalCard';
			}
			dispatch(showLoading());
			const response = await RefundAmount({
				amount: data.authorized_amount,
				transactionId: data.transactionid,
				transactionType,
				cardNumber: data.card_number,
				orderId: orderData.id,
			});
			dispatch(hideLoading());
			if (response.status === 'success') {
				Toast({ title: 'Refund Successfull', type: ToastTypes.SUCCESS });
				setSelectedIndex(3);
				refreshOrder();
			} else {
				Toast({ title: 'Refund failed', type: ToastTypes.ERROR });
			}
		} catch (error) {
			Toast({ title: 'Something went wrong', type: ToastTypes.ERROR });
		}
	};

	const voidTransaction = async (data: IPaymentDetailsInOrder) => {
		try {
			const response = await VoidTransaction({
				amount: data.authorized_amount,
				transactionId: data.transactionid,
				transactionType: data.transactionType,
				cardNumber: data.card_number,
				orderId: orderData.id,
			});

			if (response.data.void_status === 'success') {
				Toast({ title: 'Void Successfull', type: ToastTypes.SUCCESS });
				setSelectedIndex(4);
				refreshOrder();
				getStatus();
			} else {
				Toast({ title: 'Refund failed', type: ToastTypes.ERROR });
			}
		} catch (error) {
			Toast({ title: 'Something went wrong', type: ToastTypes.ERROR });
		}
	};

	const columns = [
		{
			headerName: 'Transaction Type',
			field: 'transactionType',
			flex: 1,
			renderCell: (data: any) => {
				const type = data.row.transactionType;

				return <>{type.toUpperCase()}</>;
			},
		},
		{
			headerName: 'Transaction ID',
			field: 'transactionid',
			flex: 1,
		},
		{
			headerName: 'Amount',
			field: 'authorized_amount',
			flex: 1,
			renderCell: (data: any) => (
				<>
					{' '}
					{currency} {data.row.authorized_amount}
				</>
			),
		},
		{
			headerName: 'Status',
			field: 'status',
			flex: 1,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			flex: 1,
			renderCell: (data: any) => {
				if (data.row.status === 'Settled') {
					return (
						<Button
							title='Refund Amount'
							variant='outlined'
							color='secondary'
							onClick={() => refund(data.row)}
						/>
					);
				}
				if (data.row.status === 'Unsettled') {
					return (
						<Button
							title='Void Transaction'
							variant='outlined'
							color='secondary'
							onClick={() => voidTransaction(data.row)}
						/>
					);
				}
				return <></>;
			},
		},
	];

	useEffect(() => {
		setTempdataSource([]);
		getStatus();
	}, []);

	return (
		<div className='mt-5'>
			<MUIGridGloabl
				columns={columns}
				dataSource={tempDataSource ?? []}
				rowCount={tempDataSource?.length}
			/>
		</div>
	);
}

export default Transactions;
export interface ITransactions {
	orderData: IOrderData;
	refreshOrder: () => void;
	setSelectedIndex: (index: number) => void;
}
